<!-- one pill per format; a combined format divides it per code: [IMAX|4D] -->
@if (badges.length) {
  <span class="movie-format-badge">
    @for (badge of badges; track $index) {
      @if (badge.key ? (badge.key | transloco) : badge.text; as label) {
        <span class="movie-format-code" [title]="label">{{ label }}</span>
      }
    }
  </span>
}
